import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const ReportProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Report/${props.reportId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: 'Report', method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {        
        await execute({ scope: 'update', url: `Report/${props.reportId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        let url = 'Report';

        if (!_.isEmpty(props) && !_.isEmpty(props.applicationId)) {
            url = `${url}/App/${props.applicationId}`
        }

        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `Report/${props.reportId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useReportStore = () => React.useContext(Context);
